import AdminInstallBanner, { AdminPushPrompt } from "./AdminAppBanners";
import PwaUpdateBanner from "../common/PwaUpdateBanner";
import s from "./adminApp.module.css";

/** Плавающие PWA-баннеры над нижней навигацией (не в потоке страницы). */
export default function AdminPwaBanners({ showPush = true }) {
  return (
    <div className={s.pwaBannerDock} aria-live="polite">
      <PwaUpdateBanner />
      <AdminInstallBanner />
      {showPush ? <AdminPushPrompt /> : null}
    </div>
  );
}
